import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Link, SvgIconTypeMap, SxProps, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { KheopsButtonVariant } from '../../providers/CustomThemeProvider';

export interface BackButtonProps {
  to: string;
  variant?: KheopsButtonVariant;
  shouldCheckHistory?: boolean;
  compact?: boolean;
  sx?: SxProps;
  Icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  asLink?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export default function BackButton({ to, variant = 'text', compact, sx, asLink, shouldCheckHistory = true, Icon = ArrowBackIcon, size }: BackButtonProps): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const handleBackClick = (): void => {
    if (!shouldCheckHistory || window.history.length <= 2) {
      navigate(to);
    } else {
      window.history.back();
    }
  };

  if (compact) {
    return (
      <Button
        variant={variant}
        size={size}
        onClick={handleBackClick}
        sx={{ ...sx }}
      >
        <Icon />
      </Button>
    );
  }

  if (asLink) {
    return (
      <Link
        underline="hover"
        onClick={handleBackClick}
        sx={{
          display: 'inline-flex',
          color: 'text.primary',
          alignItems: 'center',
          verticalAlign: 'middle',
          gap: '4px',
          cursor: 'pointer',
        }}
      >
        <Icon sx={{ width: '14px', height: '14px' }} />
        <Typography variant="bodySmall">
          {t('common:back')}
        </Typography>
      </Link>
    );
  }

  return (
    <Button
      variant={variant}
      onClick={handleBackClick}
      startIcon={<Icon />}
      sx={{ ...sx }}
    >
      {t('common:back')}
    </Button>
  );
}
